import { MappedEntity } from './i18next.config';

export function buildTranslationsFromMappedEntities(
  mappedEntities: MappedEntity[]
) {
  const translations: Record<string, string> = {};

  for (const {
    original_word,
    mapped_name,
    mapped_plural_name,
  } of mappedEntities) {
    translations[`${original_word}_one`] = mapped_name;
    translations[`${original_word}_other`] = mapped_plural_name;
  }

  return translations;
}

export function titlecase(input: string): string {
  const words = input.split(' ');
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );
  const result = capitalizedWords.join(' ');

  return result;
}
